<template>
  <div class="account-wrapper">
    <div class="account-wrapper-container">
      <nav class="account-wrapper-sidebar relative">
        <NuxtLink
          v-for="navItem in navigationMenuItems"
          :key="navItem.text"
          class="flex pl-3"
          :class="{ 'set-link-active': getIsSelected(navItem.to.path) }"
          :to="navItem.to"
        >
          <OSvg
            :svg="`${navItem.svgPrefix}-${getIsSelected(navItem.to.path) ? 'solid' : 'outline'}`"
            class="w-5"
            :class="{
              'fill-newBlue-400': getIsSelected(navItem.to.path),
              'fill-neutral-800': !getIsSelected(navItem.to.path)
            }"
          />
          <span
            class="o-body px-3 py-2 inline-block"
            :class="{
              'text-newBlue-400 font-bold': getIsSelected(navItem.to.path),
              'text-neutral-800': !getIsSelected(navItem.to.path)
            }"
            v-text="navItem.text"
          />
        </NuxtLink>
        <NuxtLink
          class="mt-auto flex pl-3 items-center"
          to="/customer-service"
        >
          <OSvg
            svg="question-bubble"
            class="w-5 fill-neutral-800"
          />
          <span class="o-body px-3 py-2 inline-block" v-text="$t('Navigation.FAQ')" />
        </NuxtLink>
        <span class="line" :style="{ top: `${updateLine}px` }" />
      </nav>
      <div class="account-wrapper-content">
        <div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'

export default {
  name: 'AccountWrapper',
  components: { OSvg },
  props: {
    navigationMenuItems: {
      type: Array,
      default: () => ([]),
      validator: value => value.every(obj => ['svgPrefix', 'text', 'to'].every(prop => obj.hasOwnProperty(prop)))
    }
  },
  data () {
    return {
      line: {
        itemHeight: 0,
        lineOffset: 0
      }
    }
  },
  computed: {
    updateLine () {
      return ((this.line.itemHeight - 24) / 2) + this.line.lineOffset - 8
    }
  },
  watch: {
    $route () {
      this.$nextTick(() => {
        this.setSelected()
      })
    }
  },
  mounted () {
    this.setSelected()
    window.addEventListener('resize', this.setSelected)
  },
  destroyed () {
    window.removeEventListener('resize', this.setSelected)
  },
  methods: {
    getIsSelected (path) {
      const route = this.$route.path

      if (path === this.$i18n.localePath({ name: 'account-memberships' }) && this.$route.name?.startsWith('lang-account-memberships')) {
        return true
      }

      if (path.includes('/account/personal-details') && (this.$route.name?.startsWith('lang-account-request-personal-details') || this.$route.name?.startsWith('lang-account-personal-details-security'))) {
        return true
      }

      return route === path
    },
    setSelected () {
      if (process.client) {
        this.$nextTick(() => {
        // TODO: Find a better solution (e.g. with store)
          const className = '.set-link-active'
          const selected = document.querySelectorAll(className)
          let item = null
          if (selected.length > 1) {
            item = document.querySelectorAll(className)[1]
          } else {
            item = document.querySelectorAll(className)[0]
          }
          if (!item) {
            return
          }

          this.line.itemHeight = item.clientHeight
          this.line.lineOffset = item.offsetTop
        })
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.account-wrapper {
  @apply max-w-full;

  &-container {
    @apply mx-auto;
    max-width: 119.2rem;
  }

  &-sidebar {
    display: none;
  }

  &-content {
    @apply pb-32;
  }
}

@screen lg {
  .account-wrapper {
    @apply px-4;
    background-color: #F1F2F7;
    min-height: calc(100vh - 101px);

    &-container {
      @apply flex flex-row;
      min-height: calc(100vh - 101px);
    }

    &-sidebar {
      @apply py-12 flex flex-col flex-1 border-l border-r border-neutral-200;
      min-width: 21.3rem;
      max-width: 21.3rem;
    }

    &-content {
      @apply pt-12 pl-9 flex-grow;
      max-width: calc(100% - 213px);
    }

    .line {
      @apply absolute h-10 w-1 bg-newBlue-400 rounded;
      margin-bottom: 2px;
      top: 5.6rem;
      transition: top 0.4s ease-in-out;
    }
  }
}
</style>
